// أدوات مشتركة عشان كل التطبيق يشتغل بتوقيت القاهرة بس
// (بيراعي التوقيت الصيفي/الشتوي أوتوماتيك) من غير ما يترتب على توقيت
// جهاز اللي فاتح الصفحة أو توقيت السيرفر

export const CAIRO_TZ = 'Africa/Cairo';

// تاريخ النهارده بصيغة YYYY-MM-DD بتوقيت القاهرة بالظبط
export const getCairoToday = () =>
  new Intl.DateTimeFormat('en-CA', { timeZone: CAIRO_TZ }).format(new Date());

// بتحول قيمة input من نوع datetime-local (المستخدم بيختارها على أساس إنها
// توقيت القاهرة) لصيغة ISO/UTC صحيحة، وبتحسب فرق التوقيت الصيفي/الشتوي
// بدقة بدل ما تعتمد على توقيت جهاز اللي بيدخل البيانات
export const cairoLocalToISO = (localValue) => {
  if (!localValue) return null;
  const [datePart, timePart] = localValue.split('T');
  if (!datePart || !timePart) return null;

  const [year, month, day] = datePart.split('-').map(Number);
  const [hour, minute] = timePart.split(':').map(Number);
  if ([year, month, day, hour, minute].some((n) => Number.isNaN(n))) return null;

  const utcGuess = new Date(Date.UTC(year, month - 1, day, hour, minute));

  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: CAIRO_TZ,
    hour12: false,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
    .formatToParts(utcGuess)
    .reduce((acc, p) => {
      if (p.type !== 'literal') acc[p.type] = p.value;
      return acc;
    }, {});

  const cairoAsUTC = Date.UTC(
    Number(parts.year),
    Number(parts.month) - 1,
    Number(parts.day),
    Number(parts.hour) % 24,
    Number(parts.minute),
    Number(parts.second)
  );

  const offset = cairoAsUTC - utcGuess.getTime();
  return new Date(utcGuess.getTime() - offset).toISOString();
};

// بيعرض تاريخ بتوقيت القاهرة الثابت لأي حد بيفتح الصفحة، مهما كان توقيت جهازه
export const formatCairoDate = (value) =>
  new Date(value).toLocaleDateString('ar-EG', { timeZone: CAIRO_TZ });

// بيعرض تاريخ ووقت بتوقيت القاهرة الثابت
export const formatCairoDateTime = (value) =>
  new Date(value).toLocaleString('ar-EG', { timeZone: CAIRO_TZ });
